import { CanActivateFn, Routes } from '@angular/router'
import { InbetweenAppComponent } from './inbetween/components/player/inbetween-app.component'
import { AdminComponent } from './admin/admin.component'
import { DealerComponent } from './inbetween/components/dealer/dealer.component'
import { MenuComponent } from './inbetween/components/menu/menu.component'
import { LoginComponent } from './auth/components/login/login.component'

import { RoutePathEnum } from '@shared/enums'
import { GamePanelComponent } from './inbetween/components/logger/game-panel/game-panel.component'
import { GamePanelMenuComponent } from './inbetween/components/logger/game-panel-menu.component'
import { adminGuard, authGuard, dealerGuard, loggerGuard, playerGuard } from '@core/guards'
import { StatusErrorComponent } from './auth/components/status-error/status-error.component'
import { RushMainComponent } from './inbetween/rush-components/rush-main.component'
import { LoggerMainComponent } from './inbetween/rush-components/logger/logger-main/logger-main.component'
import { ThirdAuthComponent } from './auth/components/third-party-auth/third-party-auth.component'

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: RoutePathEnum.LOGIN, pathMatch: 'full' },
      { path: 'error/:statusCode', component: StatusErrorComponent },
      {
        path: RoutePathEnum.RUSH_MAIN,
        component: RushMainComponent,
        title: 'Rush Inbetween Live',
        canActivate: [playerGuard],
      },
      {
        path: RoutePathEnum.MENU,
        component: MenuComponent,
        title: 'Pick Dealer',
        canActivate: [playerGuard],
      },
      {
        path: `${RoutePathEnum.THIRD_PARTY_AUTH}/:platformName/:username/:userToken/:sign/:gameType`,
        component: ThirdAuthComponent,
        title: 'Third Pary Auth',
      },
      {
        path: RoutePathEnum.ADMIN,
        title: 'Admin',
        component: AdminComponent,
        canActivate: [adminGuard],
        loadChildren: () => import('./admin/routes'),
      },
      {
        path: `${RoutePathEnum.CARD_GAME}/:dealerId`,
        title: 'Now Playing',
        component: InbetweenAppComponent,
        canActivate: [playerGuard],
      },
      {
        path: RoutePathEnum.DEALER,
        title: 'Dealer',
        component: DealerComponent,
        canActivate: [dealerGuard],
      },

      {
        path: RoutePathEnum.LOGGER_MENU,
        component: GamePanelMenuComponent,
        canActivate: [loggerGuard],
      },
      {
        path: RoutePathEnum.RUSH_LOGGER_MAIN,
        component: LoggerMainComponent,
        canActivate: [loggerGuard],
      },
      {
        path: `${RoutePathEnum.LOGGER}/:dealerId`,
        component: GamePanelComponent,
        canActivate: [loggerGuard],
      },
    ],
  },
  { path: RoutePathEnum.LOGIN, component: LoginComponent, title: 'Login' },
  // {
  //   path: RoutePathEnum.REGISTRAION,
  //   title: 'Registraion',
  //   component: RegistrationComponent,
  // },
  { path: '**', redirectTo: RoutePathEnum.LOGIN, pathMatch: 'full' },
]
